import { useState } from "react";
import { cn } from "@/lib/utils";

type Props = {
  name: string;
  avatarUrl?: string | null;
  platform: "instagram" | "facebook" | "messenger" | string;
  size?: "sm" | "md";
};

function initials(name: string): string {
  const cleaned = name.replace(/^Czytelniczka\s+/i, "").trim() || name;
  const parts = cleaned.trim().split(/\s+/).filter(Boolean);
  if (!parts.length) return "?";
  if (/^(FB|IG)$/i.test(parts[0]) && parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[1][0]).toUpperCase();
}

function bgFor(platform: string): string {
  const p = platform.toLowerCase();
  if (p === "instagram" || p === "ig") return "bg-gradient-to-br from-fuchsia-500 via-rose-500 to-amber-400";
  if (p === "messenger") return "bg-gradient-to-br from-violet-500 to-blue-500";
  if (p === "tiktok" || p === "tt") return "bg-slate-900";
  if (p === "youtube" || p === "yt") return "bg-red-600";
  return "bg-blue-600";
}

export default function PlatformAvatar({ name, avatarUrl, platform, size = "md" }: Props) {
  const [failed, setFailed] = useState(false);
  const dim = size === "sm" ? "h-8 w-8 text-[10px]" : "h-10 w-10 text-xs";
  const showImg = Boolean(avatarUrl) && !failed;

  return (
    <div
      className={cn(
        "relative shrink-0 overflow-hidden rounded-full text-white font-semibold",
        dim,
        !showImg && bgFor(platform),
      )}
      aria-hidden
    >
      {showImg ? (
        <img
          src={avatarUrl!}
          alt=""
          className="h-full w-full object-cover"
          onError={() => setFailed(true)}
        />
      ) : (
        <span className="flex h-full w-full items-center justify-center">{initials(name)}</span>
      )}
    </div>
  );
}
